export default "__VITE_ASSET__b6fb264b__"